import Heading from '@atlaskit/heading';
import { Box, Flex } from '@atlaskit/primitives';
import Button from '@atlaskit/button/new';
import type { OnboardingStepProps } from '../utilities/types';

export const WelcomeStep = ({ onContinue }: OnboardingStepProps) => {
	return (
		<Box>
			<Heading size="large">Welcome to Loom</Heading>
			<Flex>
				<Button appearance="primary" onClick={onContinue}>
					Continue
				</Button>
			</Flex>
		</Box>
	);
};
